import React from "react";
import Translate from "../../components/Translate";

export default function Error() {

    return (
        <div className="ns-home">
            <h1><Translate>Si è verificato un errore. Riprova più tardi</Translate></h1>
        </div>
    )
}
